const isSafari = () => {
    return "safari" in window;
};

const isSafariPushAvailable = () => {
    return isSafari() && "pushNotification" in window.safari;
};

const getSafariPermissionData = (pushId) => {
    return window.safari.pushNotification.permission(pushId);
};

/**
 * safari automatically call the backend with device token
 * @param {*} webServiceUrl
 * @param {*} pushId
 * @returns Promise
 */
const safariRequestPermission = async (webServiceUrl, pushId) => {
    return new Promise((resolve) => {
        window.safari.pushNotification.requestPermission(webServiceUrl, pushId, {}, resolve);
    });
};

const checkSafariRemotePermission = async (permissionData = {}, webServiceUrl, pushId, resolve, reject) => {
    if (permissionData.permission === "default") {
        // This is a new web service URL and its validity is unknown.
        const data = await safariRequestPermission(webServiceUrl, pushId);
        await checkSafariRemotePermission(data, webServiceUrl, pushId, resolve, reject);
    } else if (permissionData.permission === "denied") {
        reject(new Error("Safari push permission denied"));
    } else if (permissionData.permission === "granted") {
        resolve({ token: permissionData.deviceToken });
    }
};

const isPermissionGranted = (pushId) => {
    return getSafariPermissionData(pushId).permission === "granted";
};

const isPermissionDenied = (pushId) => {
    return getSafariPermissionData(pushId).permission === "denied";
};

const safariPermissionFlow = async (webServiceUrl, pushId) => {
    if (!isSafariPushAvailable()) {
        throw new Error("Safari push notification not available");
    }

    let permissionData = getSafariPermissionData(pushId);
    let token;
    try {
        ({ token } = await new Promise((resolve, reject) =>
            checkSafariRemotePermission(permissionData, webServiceUrl, pushId, resolve, reject)
        ));
    } catch (e) {
        console.warn(e.message);
    }
    return token;
};

export { isSafari, safariPermissionFlow, isPermissionGranted, isPermissionDenied };
